// extracted by mini-css-extract-plugin
export default {"root":"FrozenAccountPlaceholder-module__root","title":"FrozenAccountPlaceholder-module__title","subtitle":"FrozenAccountPlaceholder-module__subtitle"};